import { render, staticRenderFns } from "./baseheadTwo.vue?vue&type=template&id=223beaac&scoped=true"
import script from "./baseheadTwo.vue?vue&type=script&lang=js"
export * from "./baseheadTwo.vue?vue&type=script&lang=js"
import style0 from "./baseheadTwo.vue?vue&type=style&index=0&id=223beaac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223beaac",
  null
  
)

export default component.exports